import { Helper } from "../core/util/helper.js";
import React from "react";

export interface SearchInPdfInputProps {
    onChange: (value: string) => void;
    initValue: string;
}
export class SearchInPdfInput extends React.Component<SearchInPdfInputProps, { value: string; disabled: boolean; }> {
    private _eventsSet = false;
    private _inputRef: HTMLInputElement = null;

    constructor(props: SearchInPdfInputProps) {
        super(props);
        this.state = {
            value: props.initValue || "",
            disabled: false
        };
    }

    componentDidMount() {
        this._inputRef.focus();
    }

    handleStartsearch = () => {
        this.props.onChange(this._inputRef.value);
    };

    handlevalueChanged = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            this.props.onChange(this._inputRef.value);
        }
    };

    render() {

        return (
            <div>
                <label className="quicksearch__textbox">
                    <span className="k-input k-textbox k-input-solid k-input-md k-rounded-md">
                        <input type="text"
                            className="k-input-inner"
                            disabled={this.state.disabled}
                            defaultValue={this.state.value}
                            onKeyDown={this.handlevalueChanged}
                            placeholder={Helper.getTranslation("Standard.Suche")}
                            ref={(r) => { this._inputRef = r; }}
                            id="quickSearch" />
                    </span>
                    <div className="quicksearch__icon" style={{ cursor: "pointer" }} onClick={this.handleStartsearch}><i className="fal fa-play fa-fw" aria-hidden="true"></i></div>
                </label>
            </div>
        );
    }
}
